import type { ScaleOrdinal, ScaleQuantize, ScaleThreshold } from 'd3-scale';

import { SCALE_FALLBACK_COLOR } from '../../core/constants.js';
import { isString } from '../types/guards.js';
import type { XYChartColorScale } from '../types/xy-chart-internals.js';

export function getColorFromScaleAndData(
  colorScale: XYChartColorScale,
  value: string | number,
) {
  const colorDomain = colorScale.domain();
  const scaleOfNumbers = colorDomain.every(
    (value) => typeof value === 'number',
  );

  if (isString(value)) {
    const scale = colorScale as ScaleOrdinal<string, string, string>;
    return scale(value);
  }

  if (scaleOfNumbers) {
    const [min, max] = [colorDomain[0], colorDomain[colorDomain.length - 1]];
    if (value >= min && value <= max) {
      const scale = colorScale as
        | ScaleQuantize<string>
        | ScaleThreshold<number, string>;
      return scale(value);
    }
  }

  return SCALE_FALLBACK_COLOR;
}
